<template>
  <b-container fluid>
    <b-row>
      <b-col class="top_bar" />
    </b-row>
    <b-row
      ><b-col><div class="page_title">Question Bank</div></b-col></b-row
    >
    <b-row>
      <b-col class="col-6 indentation-left indentation-right question_list">
        <b-row
          ><b-col>
            <div class="mb-3">
              Search by course, exam, question, or keyword...
            </div>
          </b-col></b-row
        >
        <b-row class="mb-4">
          <b-col class="col-auto">
            <div class="search_input">
              <span class="fa fa-search search_input-icon" />
              <input
                v-model="searchString"
                type="text"
                class="form-control tsny_input search_input-input"
              />
            </div>
          </b-col>
          <b-col class="col-auto">
            <b-select
              v-model="courseFilter"
              :options="filterOptions"
              class="tsny_button tsny_dropdown custom_select"
            />
          </b-col>
          <b-col class="col-auto">
            <b-button class="tsny_button" @click="openQuestionForm"
              >Ask a Question</b-button
            >
          </b-col>
        </b-row>
        <b-row v-for="question in searchResults" :key="question._id">
          <b-col>
            <question
              class="mb-3"
              :question="question"
              @click.native="questionSelected(question)"
            />
          </b-col>
        </b-row>
      </b-col>
      <b-col class="indentation-left indentation-right">
        <question-form v-if="showQuestionForm" :courses="filterOptions" />
        <question-detail
          v-if="showQuestionDetail"
          :question="selectedQuestion"
          @update-question="updateQuestion"
          @delete-question="deleteQuestionHandler"
        />
      </b-col>
    </b-row>
    <update-question-modal
      v-if="isStaff"
      :original-question="selectedQuestion"
    />
    <delete-question-modal v-if="isStaff" :question="selectedQuestion" />
  </b-container>
</template>

<script>
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import QuestionBankRestService from "../../services/rest/services/QuestionBankRestService";
import Question from "../../components/QuestionBank/Question";
import QuestionForm from "../../components/QuestionBank/QuestionForm";
import QuestionDetail from "../../components/QuestionBank/QuestionDetail";
import UpdateQuestionModal from "../../components/QuestionBank/UpdateQuestionModal";
import DeleteQuestionModal from "../../components/QuestionBank/DeleteQuestionModal";
import FlexSearch from "flexsearch/flexsearch";

export default {
  name: "QuestionBank",
  components: {
    UpdateQuestionModal,
    DeleteQuestionModal,
    QuestionDetail,
    Question,
    QuestionForm
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      defaultCourse: StoreConstants.GETTERS.COURSE,
      courseObjects: StoreConstants.GETTERS.COURSE_OBJECTS,
      isStaff: StoreConstants.GETTERS.IS_STAFF
    }),
    filterOptions() {
      return [
        {
          value: null,
          text: "No Course Filter"
        },
        {
          value: "General",
          text: "General Questions"
        },
        ...this.courseObjects.map(course => course._id)
      ];
    },
    index() {
      let index = new FlexSearch("default", {
        doc: {
          id: "_id",
          field: [
            "question",
            "description",
            "answer",
            "questionType",
            "topic",
            // FlexSearch will throw an error if questionDetails is not defined for a question because it apparently doesn't know how to null check here either -__-
            "questionDetails:book",
            "questionDetails:chapter",
            "questionDetails:page",
            "questionDetails:exam",
            "questionDetails:section",
            "questionDetails:questionNumber"
          ]
        }
      });
      index.add(this.questions);
      return index;
    },
    searchResults() {
      let $comp = this;
      try {
        if ($comp.searchString && $comp.searchString.length) {
          return $comp.index.search($comp.searchString, {
            where: function(item) {
              return (
                !$comp.courseFilter || item.courses.includes($comp.courseFilter)
              );
            }
          });
        } else {
          // This is atrocious but necessary until FlexSearch gets its shit together.
          // The package doesn't do proper null/empty checking on search queries which means that a null search throws an error and an empty search returns no results
          return $comp.index.where(item => {
            return (
              !$comp.courseFilter || item.courses.includes($comp.courseFilter)
            );
          });
        }
      } catch (error) {
        console.log(error);
        return $comp.questions;
      }
    }
  },
  data: function() {
    return {
      questions: [],
      courseFilter: null,
      searchString: null,
      showQuestionForm: null,
      showQuestionDetail: null,
      selectedQuestion: null
    };
  },
  mounted: function() {
    if (this.id) {
      this.courseFilter = this.defaultCourse(this.id).course._id;
    }
    return QuestionBankRestService.getQuestions()
      .then(response => {
        this.questions = response.data || {};
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    openQuestionForm() {
      this.showQuestionForm = true;
      this.showQuestionDetail = false;
    },
    questionSelected(question) {
      this.selectedQuestion = question;
      this.showQuestionForm = false;
      this.showQuestionDetail = true;
    },
    updateQuestion() {
      this.$bvModal.show("updateQuestionModal");
    },
    deleteQuestionHandler() {
      this.$bvModal.show("deleteQuestionModal");
    }
  }
};
</script>

<style scoped>
.indentation-left {
  padding-left: 60px;
}

.indentation-right {
  padding-right: 60px;
}

.tsny_dropdown:focus {
  box-shadow: none;
  background-color: #f8f8f8;
}

.tsny_dropdown option {
  padding: 5px;
  border: 1px solid lightgray;
}

datalist {
  border: 0;
}

.question_list {
  overflow-y: scroll;
  scrollbar-width: thin;
  scrollbar-color: #969696 #969696;
  max-height: calc(100vh - 140px);
}
</style>
